//@flow
import {unwrap} from "./func-unwrapper";
import {finder} from './dom-finders';
import ko from 'rgs-knockout';


export type LodashFunctor = (Object) => string

export type rendererArguments = {
	model: *,
	intoHtml?: any;
	selector: string,
	template: LodashFunctor | string;
}

const render = (params: rendererArguments) => {
	const {model, selector: selectorId, template, intoHtml} = params;

	const element = finder(selectorId);

	if (!element) {
		return;
	}

	ko.applyBindingsToNode(element, {
		template: {
			html: unwrap(template, intoHtml),
			data: model,
		},
	});
};

export {
	render,
};
